import { clsx } from 'clsx'
import { type FC, type PropsWithChildren } from 'react'

type ProductFormattedUnitPriceProps = PropsWithChildren<{
  classNames?: string
}>

export const ProductFormattedUnitPrice: FC<ProductFormattedUnitPriceProps> = ({
  children,
  classNames,
}) => {
  return (
    <div
      className={clsx('text-dark-primary-strong', classNames)}
      data-qa-id="current-variant-price-per-unit"
    >
      {children}
    </div>
  )
}
